import React, { useRef } from "react";
import { contactFormValidationSchema } from "../../../utils/formikValidateForm";
import { Formik, Form, ErrorMessage } from "formik";
import InputField from "../../../components/InputField";
import TextArea from "../../../components/TextArea";
import { ButtonSubmit } from "../../../components/Button";
import { form_section_data } from "../../../data/contactData";
import { useDispatch, useSelector } from "react-redux";
import { postContactRequest } from "../ReduxStore/actions";
import ReCAPTCHA from "react-google-recaptcha";
import { clientSiteKey } from "../../../api/reCaptchaKey";
import { contact_map_url } from "../../../data/mapUrlData";

const FormSection = () => {
  const recaptchaRef = useRef(null);

  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.contactData);

  const handleFormSubmit = (values, { setSubmitting, resetForm }) => {
    dispatch(postContactRequest(values));
    setSubmitting(false);
    resetForm();
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  return (
    <div className="md:flex md:flex-col md:items-center w-full lg:flex lg:flex-row lg:items-start">
      <div className="lg:w-1/2 px-[5vw] sm:px-[10vw] md:px-[10vw] py-[5vh] lg:px-[8vw] md:w-[800px] space-y-4">
        <div className="text-center space-y-2">
          <h1 className="uppercase text-xl lg:text-2xl font-playfair">
            {form_section_data.title}
          </h1>
          <p className="text-yellow-200">{form_section_data.description}</p>
        </div>
        <Formik
          initialValues={{
            name: "",
            email: "",
            subject: "",
            message: "",
            recaptcha: "",
          }}
          validationSchema={contactFormValidationSchema}
          onSubmit={handleFormSubmit}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form className="flex flex-col gap-3 py-5 w-full justify-start items-start rounded">
              <div className="flex flex-col mb:flex-row gap-3 w-full">
                <InputField type="text" name="name" placeholder="Name*" />
                <InputField type="text" name="email" placeholder="Email*" />
              </div>
              <InputField type="text" name="subject" placeholder="Subject*" />
              <TextArea name="message" placeholder="Message*" />
              <div>
                <ReCAPTCHA
                  sitekey={clientSiteKey}
                  onChange={(value) => setFieldValue("recaptcha", value)}
                  size="normal"
                  ref={recaptchaRef}
                />
                <ErrorMessage
                  name="recaptcha"
                  component="div"
                  className="text-red-900 text-[12px]"
                />
              </div>
              <ButtonSubmit
                type="submit"
                name="SUBMIT"
                className="px-6 py-2 w-full mt-6 uppercase bg-yellow-light text-ash-500"
                disabled={isSubmitting}
                loader={isLoading}
              />
            </Form>
          )}
        </Formik>
      </div>
      {/* GoogleMap 1 for mobile view*/}
      <div className="px-[5vw] sm:px-[10vw] md:px-[10vw] pb-[10vh] lg:px-[5vw] lg:hidden">
        <div className="text-center space-y-2 py-[3vh]">
          <h1 className="uppercase text-center text-xl lg:text-2xl font-playfair">
            Our Presence
          </h1>

          <p className="text-yellow-200 uppercase text-center">
            Suite 909/Level 9, 155 Castlereagh street, Sydney
          </p>
        </div>
        <div className="max-w-[600px] max-h-[300px] md:min-w-[600px] md:min-h-[300px] lg:max-w-[300px] lg:max-h-[500px]">
          <iframe
            title="Goggle Embedded Content"
            src={contact_map_url}
            loading="lazy"
            width="600"
            height="300"
            style={{ width: "100%" }}
          ></iframe>
        </div>
      </div>

      {/* GoogleMap 2 for pc view*/}
      <div className="hidden lg:w-1/2 lg:py-[2vh] lg:px-[5vw] lg:flex lg:flex-col ">
        <div className="text-center space-y-2 py-[3vh]">
          <h1 className="uppercase text-center text-xl lg:text-2xl font-playfair">
            Our Presence
          </h1>

          <p className="text-yellow-200 uppercase text-center">
            Suite 909/Level 9, 155 Castlereagh street, Sydney
          </p>
        </div>
        {/* Responsive iframe container using aspect ratio */}
        <div
          className="w-full max-w-[600px] lg:mx-auto"
          style={{ aspectRatio: "4 / 3" }}
        >
          <iframe
            title="Google Embedded Content"
            src={contact_map_url}
            loading="lazy"
            className="w-full h-full border-0"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default FormSection;
